import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Heart } from "lucide-react";

// "2026-07-27" → local midnight (not UTC). Anything else → native parse.
export function parseWeddingDate(value) {
  if (!value) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value).trim());
  const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function split(ms) {
  return {
    d: Math.floor(ms / 86400000),
    h: Math.floor((ms / 3600000) % 24),
    m: Math.floor((ms / 60000) % 60),
    s: Math.floor((ms / 1000) % 60),
  };
}

function FlipDigit({ value, testid }) {
  const text = String(value).padStart(2, "0");
  return (
    <div className="relative h-10 md:h-12 overflow-hidden [perspective:400px]" data-testid={testid}>
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.div
          key={text}
          initial={{ rotateX: -90, opacity: 0 }}
          animate={{ rotateX: 0, opacity: 1 }}
          exit={{ rotateX: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="font-serif text-3xl md:text-4xl font-light text-[var(--ink)] tabular-nums leading-10 md:leading-[3rem] origin-center"
        >
          {text}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

const Cell = ({ val, label }) => (
  <div className="flex flex-col items-center min-w-[58px]">
    <FlipDigit value={val} testid={`countdown-${label.toLowerCase()}`} />
    <div className="text-[10px] uppercase tracking-[0.18em] text-[var(--muted)] mt-1">{label}</div>
  </div>
);

const Sep = () => <span className="text-[var(--gold)] font-serif text-xl">:</span>;

export default function CountdownCard({ names = "", date, subtitle = "Countdown to our big day" }) {
  const target = parseWeddingDate(date);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);

  const married = target && now >= target.getTime();
  const t = target ? split(Math.abs(target.getTime() - now)) : null;
  const formatted = target
    ? target.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
    : "Date to be announced";

  return (
    <div data-testid="countdown-card" className="glass-light rounded-2xl p-6 md:p-8 w-[300px] md:w-[340px]">
      {names && <p className="font-script text-3xl text-[var(--ink)] text-center mb-1">{names}</p>}
      <p className="text-center text-[var(--muted)] text-sm mb-1" data-testid="countdown-date">{formatted}</p>
      <p className="text-center text-[10px] uppercase tracking-[0.22em] text-[var(--gold)] mb-4 flex items-center justify-center gap-1.5" data-testid="countdown-subtitle">
        {married && <Heart className="w-3 h-3 fill-current" />}
        {married ? (t.d === 0 ? "Just married today" : "Happily married for") : subtitle}
      </p>
      {t && (
        <div className="flex items-center justify-between gap-2">
          <Cell val={t.d} label="Days" /><Sep />
          <Cell val={t.h} label="Hours" /><Sep />
          <Cell val={t.m} label="Minutes" /><Sep />
          <Cell val={t.s} label="Seconds" />
        </div>
      )}
    </div>
  );
}
